import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import TableInvoicesPending from "@/components/TableInvoicesPending.vue";
import TableInvoices from "@/components/TableInvoices.vue";
import TableInvoicesAll from "./TableInvoicesAll.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInvoices',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TabView), null, {
    default: _withCtx(() => [
      _createVNode(_unref(TabPanel), { header: "Invoices Pending" }, {
        default: _withCtx(() => [
          _createVNode(TableInvoicesPending)
        ]),
        _: 1
      }),
      _createVNode(_unref(TabPanel), { header: "Invoices Confirmed" }, {
        default: _withCtx(() => [
          _createVNode(TableInvoices)
        ]),
        _: 1
      }),
      _createVNode(_unref(TabPanel), { header: "All ANAF invoices " }, {
        default: _withCtx(() => [
          _createVNode(TableInvoicesAll)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})